import { FadeIn } from "./Reveal";

const categories = [
  {
    name: "Opere Edili",
    items: [
      "Ristrutturazioni e Costruzioni",
      "Strutture in cartongesso e rasatura",
      "Rifacimento cortili e opere di scavo",
      "Tetti, solai e linee vita",
      "Impermeabilizzazioni",
      "Vespai ventilati",
    ],
  },
  {
    name: "Impianti e Finiture",
    items: [
      "Opere idrauliche ed elettriche",
      "Fornitura e installazione infissi",
      "Decorazioni",
      "Resine e microcemento",
    ],
  },
  {
    name: "Opere Specialistiche e Risanamento",
    items: [
      "Colonne di scarico condominiale",
      "Rimozione e bonifica amianto",
    ],
  },
  {
    name: "Progettazione",
    items: [
      "Studio di progettazione",
      "Render 3D",
      "Pratiche",
    ],
  },
];

const Dot = () => (
  <span className="mt-3 w-1 h-1 shrink-0 rounded-full bg-[#1C1B1A]" aria-hidden="true" />
);

export default function Services() {
  return (
    <section id="attivita" data-testid="services-section" className="relative bg-[#F4F1EA] border-y border-black/10">
      <div className="max-w-6xl mx-auto px-6 lg:px-10 py-28 lg:py-36">
        <FadeIn>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-[#1C1B1A]"><span className="inline-block border-b border-[#E30613] pb-1">Servizi</span></h2>
          <p className="mt-4 italic font-display text-2xl sm:text-3xl font-medium tracking-tight text-[#1C1B1A]">
            Soluzioni complete per ogni intervento
          </p>
        </FadeIn>

        <div className="mt-16 lg:mt-24 grid md:grid-cols-2 gap-x-16 gap-y-16 lg:gap-y-20">
          {categories.map((cat, ci) => (
            <FadeIn key={cat.name} delay={ci * 0.08}>
              <div data-testid={`service-category-${ci}`}>
                <h3 className="text-xs font-bold uppercase tracking-[0.25em] text-[#1C1B1A] flex items-center gap-4">
                  <span className="w-8 h-px bg-[#E30613]" />
                  {cat.name}
                </h3>
                <div className="mt-8 flex flex-col items-start gap-6">
                  {cat.items.map((item, ii) => (
                    <div key={item} data-testid={`service-item-${ci}-${ii}`} className="group flex items-start gap-3 cursor-default">
                      <Dot />
                      <span className="font-display text-xl sm:text-2xl font-medium text-[#1C1B1A] group-hover:text-[#E30613] transition-colors duration-500 leading-snug">
                        {item}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </FadeIn>
          ))}
        </div>
      </div>
      <img src="/fkl-logo.png" alt="" aria-hidden="true" className="absolute bottom-5 right-6 w-16 sm:w-20 pointer-events-none" />
    </section>
  );
}
